module.exports = __webpack_public_path__ + "img/asbj.6db15110.png";